import { isNumber as a, isStringNumber as c } from "./index565.js";
import { isString as m, camelize as u } from "./index575.js";
import { debugWarn as f } from "./index588.js";
import { isClient as d } from "./index599.js";
const l = "utils/dom/style", e = (t = "") => t.split(" ").filter((r) => !!r.trim()), C = (t, r) => {
  if (!t || !r) return !1;
  if (r.includes(" ")) throw new Error("className should not contain space.");
  return t.classList.contains(r);
}, S = (t, r) => {
  !t || !r.trim() || t.classList.add(...e(r));
}, h = (t, r) => {
  !t || !r.trim() || t.classList.remove(...e(r));
}, w = (t, r) => {
  var n;
  if (!d || !t || !r) return "";
  let s = u(r);
  s === "float" && (s = "cssFloat");
  try {
    const i = t.style[s];
    if (i) return i;
    const o = (n = document.defaultView) == null ? void 0 : n.getComputedStyle(t, "");
    return o ? o[s] : "";
  } catch {
    return t.style[s];
  }
};
function L(t, r = "px") {
  if (!t && t !== 0) return "";
  if (a(t) || c(t))
    return `${t}${r}`;
  if (m(t))
    return t;
  f(l, "binding value must be a string or number");
}
export {
  S as addClass,
  L as addUnit,
  e as classNameToArray,
  w as getStyle,
  C as hasClass,
  h as removeClass
};
